defaultOperationType